<div class="workSpace">
  <!--nombre y filtro-->
<div class="w3-container w3-containertemplate headersTab">
  <!--Nombre modulo y tablero-->
  <div class="w3-caja-menu padreizquierda w3-quarter">
    <div class="w3-row hijoizquierda centradoVertical">
      <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"> <b> {{ 'menu.'+dataService.moduleSelect | translate}}</b></span>
      <span class="w3-text-deep-orange">&bull;</span>
      <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal"> {{ 'menu.'+dataService.subModuleSelect | translate }}</span>
    </div>
  </div>
  <!--FILTROS-->
  <div class="w3-caja-menu padreizquierda w3-rest ">
    <div class="zonasFiltros w3-row centradoVertical">
      <div class="w3-half">
          <div class="w3-right" style="margin-right: 5%;" [ngClass]="{ 'w3-disabled': !filtroPeriodos }">
            {{ 'filtros.rango' | translate }}
          </div>
          <div class="w3-right" style="margin-right: 5%; margin-top: 1%;">
            <input (click)="activacionFiltros()" class="" style="border-width: 1px;" type="checkbox">
          </div>
      </div>
      <div class="w3-rest"  [ngClass]="{ 'w3-disabled': !filtroPeriodos }">
        {{ 'filtros.desde' | translate }}

        @for (anio of Periodos; track $index) {
          @for (mes of anio.series; track $index) {
            <div [ngClass]="{ 'fraseFil w3-round-btn-large w3-center w3-elemento-menu grisBtn w3-button iconoFiltros': mes.check, 'w3-hide': !mes.check}"
            [matMenuTriggerFor]="menuAniosIni">
              <span style="margin-left: 5px;">{{escrituraPeriodo(mes.periodo)}}</span>
            </div>
          }
        }
        <mat-menu class="w3-medium" #menuAniosIni="matMenu">
          @for (anio of Periodos; track $index) {
            <button class="mat-menu-item" mat-menu-item [matMenuTriggerFor]="menuMeses">
              {{anio.anio}}
            </button>
            <mat-menu #menuMeses="matMenu" [overlapTrigger]="false">
              @for (mes of anio.series; track $index) {
                <button mat-menu-item (click)="$event.stopPropagation(); cambioPeriodo(mes, 'inicio');">
                  <input [id]="'check_'+mes.mes+''+mes.anio"
                  (change)="cambioPeriodo(mes, 'inicio')" style="cursor: pointer; margin-top: 0.7vh; float: left;"
                  [checked]="mes.check" type="checkbox"
                  (click)="$event.stopPropagation();">
                  <span style="margin-left: 5px; float: left;">{{'filtros.'+mes.mes|translate}}</span> 
                </button>
              }
            </mat-menu>
          }
        </mat-menu>

        {{ 'filtros.hasta' | translate }}

        @for (anio of Periodos2; track $index) {
          @for (mes of anio.series; track $index) {
            <div [ngClass]="{ 'fraseFil w3-round-btn-large w3-center w3-elemento-menu grisBtn w3-button iconoFiltros': mes.check, 'w3-hide': !mes.check}"
            [matMenuTriggerFor]="menuAniosFin">
              <span style="margin-left: 5px;">{{escrituraPeriodo(mes.periodo)}}</span>
            </div>
          }
        }
        <mat-menu class="w3-medium" #menuAniosFin="matMenu">
          @for (anio of Periodos2; track $index) {
            @if (anio.visible) {
              <button class="mat-menu-item" mat-menu-item [matMenuTriggerFor]="menuMeses2">
                {{anio.anio}}
              </button>
            }
            <mat-menu #menuMeses2="matMenu" [overlapTrigger]="false">
              @for (mes of anio.series; track $index) {
                @if (mes.visible) {
                  <button mat-menu-item (click)="$event.stopPropagation(); cambioPeriodo(mes, 'fin');">
                    <input [id]="'check_'+mes.mes+''+mes.anio"
                    (change)="cambioPeriodo(mes, 'fin')" style="cursor: pointer; margin-top: 0.7vh; float: left;"
                    [checked]="mes.check" type="checkbox"
                    (click)="$event.stopPropagation();">
                    <span style="margin-left: 5px; float: left;">{{'filtros.'+mes.mes|translate}}</span> 
                  </button>
                }
              }
            </mat-menu>
          }
        </mat-menu>
      </div>
    </div>
  <!--FILTRO PERSPECTIVA-->
    <div class="w3-quarter centradoVertical" style="margin-right: 1vh;">
      <div class="w3-half hijoizquierda">
        <button class="w3-button w3-right" [matMenuTriggerFor]="menuPerspectivas">
          {{ 'filtros.pers' | translate }}
          <mat-icon class="iconoMen">expand_more</mat-icon>
        </button>
        <mat-menu class="w3-medium" #menuPerspectivas="matMenu">
          @for (i of perspectivas; track $index) {
            <button class="mat-menu-item" mat-menu-item [ngClass]="{'w3-disabled':encPers === i}" [disabled]="encPers === i" (click)="$event.stopPropagation(); cambioPerspectiva(i);">
              <span>{{i}}</span>
            </button>
          }
        </mat-menu>
      </div>
      <!--Chip perspectiva seleccionada-->
      <div class="w3-rest hijoizquierda">
        <div class="w3-row padreizquierda containerChips">
          <div class="chips nombres">
            <div class="autoAjuste">
              @for (anio of Periodos; track $index) {
                @for (mes of anio.series; track $index) {
                  <div [ngClass]="{
                    'w3-round-btn-large grisBtn w3-center w3-elemento-menu w3-button':mes.check,
                    'w3-hide':!mes.check}" class="filtroMesAnioSeleccionado">
                    <span style="margin-left: 5px;">{{encPers}}</span>
                  </div>
                }
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</div>

<!--CONTENIDO DEL TABLERO-->
<div class="w3-row workSpaceTab">
  <div class="zonaSup w3-white">
    <div class="w3-row headers w3-titulo-contenidomenuSC">
      <div class="w3-half">
        <span class="w3-margin-left-contenido">{{'operative.analisis.tituloTabla' | translate}}</span>
        <span class=""> {{encPers.toLowerCase()}} </span>
        @if (filtroPeriodos) {
          <span class="w3-margin-left-contenido">&bull;</span>
          <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPeriodo(subTitles)}} - {{escrituraPeriodo(subTitles2)}}</span>
        }
      </div>
      <div class="w3-rest w3-right">
        <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            [matMenuTriggerFor]="menuTabla">
              more_vert
            </mat-icon>
            <mat-menu #menuTabla="matMenu">
              <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportarExcel()">
                <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
                <span>{{'menu.Exportar' | translate}}</span>
              </button>
            </mat-menu>
      </div>
    </div>
    <div class="zonaTabla w3-scroll">
      <table class="w3-table borderInf">
        <thead>
          <tr class="w3-table-titleLow w3-center">
            <th class="w3-border-right-balance stikyColumBlanco"></th>
            <th class="w3-border-right-balance stikyColumCon " colspan="2">{{'operative.analisis.titulo2'|translate}}</th>
            <th class="w3-border-right-balance stikyColumCon" colspan="2">{{'operative.analisis.titulo3'|translate}}</th>
            <th class="w3-border-right-balance stikyColumCon" colspan="2">{{'operative.analisis.titulo4'|translate}}</th>
          </tr>
          <tr class="w3-table-title">
            <th class="w3-border-right-balance w3-center stikyColumCon2">{{encPers}}</th>
            <th class="w3-border-right-balance w3-center stikyColumCon2" >{{'operative.analisis.encabezado1'|translate}}</th>
            <th class="w3-border-right-balance w3-center stikyColumCon2" >%</th>
            <th class="w3-border-right-balance w3-center stikyColumCon2" >{{'operative.analisis.encabezado2'|translate}}</th>
            <th class="w3-border-right-balance w3-center stikyColumCon2" >{{'operative.analisis.encabezado3'|translate}}</th>
            <th class="w3-border-right-balance w3-center stikyColumCon2" >{{'operative.analisis.encabezado2'|translate}}</th>
            <th class="w3-border-right-balance w3-center stikyColumCon2" >{{'operative.analisis.encabezado3'|translate}}</th>
          </tr>
        </thead>
        @for (item of dataOrdenado; track $index) {
          <tbody>
            <tr class="w3-table-trtd borderInfLow" [ngClass]="{'filaTotales': item.categoria=== 'Total general'}">
              <td class="borderAllLow "><span>{{item.categoria}}</span></td>
              <td class="borderAllLow anchos alinCenter"><span style="margin-right: 5%;">{{item.numEven}}</span></td>
              <td class="borderAllLow anchos alinCenter"><span style="margin-right: 5%;">{{item.porEven}} %</span></td>
              <td class="borderAllLow anchos alinCenter"><span style="margin-right: 5%;">{{item.numRies}}</span></td>
              <td class="borderAllLow anchos alinCenter">
                <div [ngClass]="pintarNivelRiesgo(item.numRies)">
                  <span style="margin-right: 5%;">{{item.nivRies}}</span>
                </div>
              </td>
              <td class="borderAllLow anchos alinCenter"><span style="margin-right: 5%;">{{item.numExp}}</span></td>
              <td class="borderAllLow anchos alinCenter">
                <div [ngClass]="pintarNivelExp(item.numExp)">
                  <span style="margin-right: 5%;">{{item.nivExp}}</span>
                </div>
              </td>
            </tr>
          </tbody>
        }
      </table>
    </div>
  </div>
  <div class="zonaInf w3-white" id="conteGraf">
    <div class="w3-row headers w3-titulo-contenidomenuSC">
      <div class="w3-half"> <!--titulo tabla-->
        <span class="w3-margin-left-contenido">{{
          'operative.analisis.tituloGraf' + encMet | translate}}
        </span>
        <span class=""> {{encPers.toLowerCase()}} </span>
        @if(filtroPeriodos){
          <span class="w3-margin-left-contenido">&bull;</span>
          <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPeriodo(subTitles)}} - {{escrituraPeriodo(subTitles2)}}</span>
        }
      </div>
      <!--menu grafica-->
      <div class="w3-rest w3-right"> 
        @if (labelsGrafica) {
          <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}" (click)="etiquetasGraf1(false)">
            label_off
          </mat-icon>
        }@else {
          <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}" (click)="etiquetasGraf1(true)">
            label
          </mat-icon>
        }
        <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}" (click)="ampliarGraf()">
          zoom_out_map
        </mat-icon>
        <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
        [matMenuTriggerFor]="menuGrafica">
          more_vert
        </mat-icon>
        <mat-menu #menuGrafica="matMenu">
          <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="tipoGrafica">
            <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">assessment</mat-icon>
            <span>{{'menu.graficas'|translate}}</span>
          </button>
          <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="menuMetrica">
            <mat-icon [ngStyle]="{'color':'gray'}">tag</mat-icon>
            <span>{{'menu.Metrica' | translate}}</span>
          </button>
          <!--<button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportarGrafica('conteGrafica', 'credito.concentracion.tituloTabla' + , encPerspectiva)">-->
          <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportarGrafica('conteGraf', 'operative.analisis.tituloGraf' + encMet, encPers.toLowerCase())">
            <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
            <span>{{'menu.Exportar' | translate}}</span>
          </button>
        </mat-menu>
        <mat-menu #tipoGrafica="matMenu">
          <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [ngClass]="{'w3-disabled':tipoGraf === 'bar'}" [disabled]="tipoGraf === 'bar'" (click)="grafica('bar')">
            <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
            <span>{{'graf.barras'|translate}}</span>
          </button>
          <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [ngClass]="{'w3-disabled':tipoGraf === 'line'}" [disabled]="tipoGraf === 'line'" (click)="grafica('line')">
            <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
            <span>{{'graf.lineal'|translate}}</span>
          </button>
          <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [ngClass]="{'w3-disabled':tipoGraf === 'area'}" [disabled]="tipoGraf === 'area'" (click)="grafica('area')">
            <mat-icon [ngStyle]="{'color':'gray'}">area_chart</mat-icon>
            <span>{{'graf.area'|translate}}</span>
          </button>
        </mat-menu>
        <mat-menu #menuMetrica="matMenu">
          <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [ngClass]="{'w3-disabled':encMet === 1}" [disabled]="encMet === 1"  (click)="cambioMetrica('riesgo')">
            <span>{{'operative.analisis.metrica1'|translate}}</span>
          </button>
          <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [ngClass]="{'w3-disabled':encMet === 2}" [disabled]="encMet === 2" (click)="cambioMetrica('exposicion')">
            <span>{{'operative.analisis.metrica2'|translate}}</span>
          </button>
        </mat-menu>
      </div>
    </div>
    <br>
    <div class="zonaGraf" >
      <div id="grafica"></div>
    </div>
  </div>
</div>
</div>

<!--Modal ampliar grafica-->
<div id="ampliar" class="modal" (click)="clickFuera($event)">
<div class="modalContent " style="width: 80%;">
  <div class="w3-row w3-white">
    <!--Titulo grafica modal-->
    <div class="w3-row w3-noventa2 w3-white">
      <div class="w3-row  w3-header-cuadrante padreizquierda" style="height: 6vh; margin-top: 10px; margin-left: 20px">
        <div class="w3-noventa2 w3-titulo-contenidomenu bottom hijoizquierdaTitle" >
          <span class="w3-margin-left-contenido">{{
            'operative.analisis.tituloGraf' + encMet | translate}}
          </span>
          <span class=""> {{encPers.toLowerCase()}} </span>
          @if(filtroPeriodos){
            <span class="w3-margin-left-contenido">&bull;</span>
            <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPeriodo(subTitles)}} - {{escrituraPeriodo(subTitles2)}}</span>
          }
        </div>
      </div>
    </div>
    <!--cerrar modal-->
    <div class="w3-rest w3-right w3-white" style="height: 6vh; margin-top: 10px;">
      <div class="w3-row" style="height: 3vh; transform: translate(0, 40%);">
        <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" (click)="closeModal()">clear</mat-icon>
      </div>
    </div>
  </div>
  
  <!--area grafica-->
  <div style="padding-left: 2%; padding-bottom: 1%; padding-right: 2%;">
    <ng-container>
      <div class="w3-row contentGraf">
        <div id="graficaAmpliada"></div>
      </div>
    </ng-container>
  </div>
</div>
</div>